<template>
  <div>
    <div slot="title">
      <h2>Nombramientos</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <h6>Buscar empleado nombrado</h6>
          </div>
        </div>
        <div class="row">
          <div class="form-group-h col-3">
            <input
              v-model="busquedaPersonaParaNombramiento"
              class="form-control"
              type="text"
              placeholder="Nombre del empleado"
            />
          </div>
          <div class="form-group d-flex align-items-center col-3">
            <button
              type="button"
              v-on:click="BuscarPersonasParaNombramiento()"
              class="btn btn-primary"
            >
              Buscar
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <h6>Seleccionar empleado nombrado</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-12 table-responsive">
            <table
              class="table  table-striped table-light table-hover"
              id="tabla_PersonaDelNombramiento"
              data-toggle="table"
              data-pagination="true"
              data-page-size="5"
              data-search="true"
              data-single-select="true"
              data-click-to-select="true"
            >
              <thead class="thead-custom">
                <tr>
                  <th data-checkbox="true"></th>
                  <th
                    data-field="PersonaNombrada.PersonaId"
                    data-sortable="true"
                  >
                    Persona Id
                  </th>
                  <th data-field="PersonaNombrada.Nombre" data-sortable="true">
                    Nombre
                  </th>
                  <th
                    data-field="PersonaNombrada.ApellidoPaterno"
                    data-sortable="true"
                  >
                    Apellido Paterno
                  </th>
                  <th
                    data-field="PersonaNombrada.ApellidoMaterno"
                    data-sortable="true"
                  >
                    Apellido Materno
                  </th>
                  <!-- <th                       
                    data-events="operateEvents"                 
                    :data-formatter="this.operateFormatter()"
                  >
                    Acciones
                  </th> -->
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="form-group-h col-6">
            <label for="numeroDeOficio">Número de oficio</label>
            <input
              id="numeroDeOficio"
              v-model="numeroDeOficio"
              class="form-control"
              type="number"
              placeholder="Número de oficio"
            />
          </div>
          <div class="form-group-h col-6">
            <label for="tiposAsuntoId">Asunto</label>
            <C043TiposAsunto 
              :idDelInput="'tiposAsuntoId'"
              :parametros="{}"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              v-on:valorParaElPadre="CambioTipoAsunto"
              > </C043TiposAsunto>
          </div>
          <!--<div class="form-group col-12">
            <label>Fundamento Legal</label>
            <C036FundamentosLegales
              :placeholder="'Seleccione fundamento legal'"
              v-on:valorParaElPadre="CambioFundamentoLegal"
            >
            </C036FundamentosLegales>
          </div>-->
           <!--<div class="form-group col-12">
            <label>Tipo Plantilla</label>

            <C037TiposPlantillasDeNombramientos
              :valorDefinido="0"
              :hereda="this.fundamentoLegalId"
              :idDelInput="'tiposPlantillasDeNombramientosId'"
              :parametros="{}"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :key="this.fundamentoLegalId"
              v-on:valorParaElPadre="CambioTipoPlantillaSeleccionada"
            >
            </C037TiposPlantillasDeNombramientos>
          </div>-->
          <!-- <div class="form-group-h col-6">
            <label for="expediente">Expediente</label>
            <input
              id="expediente"
              v-model="expediente"
              class="form-control"
              type="text"
              placeholder="Expediente"
            />
          </div> -->
          <div class="form-group-h col-6">
            <label>Fecha de expedición</label>
            <input
              v-model="fechaDeExpedicion"
              class="form-control"
              type="date"
              placeholder="Fecha de expedición"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group-h col-6">
            <label>Fecha Inicial del Nombramiento</label>
            <input
              v-model="fechaInicial"
              class="form-control"
              type="date"
              placeholder="Fecha Inicial"
            />
          </div>
          <div class="form-group-h col-6">
            <label>Fecha Final del Nombramiento</label>
            <input
              v-model="fechaFinal"
              class="form-control"
              type="date"
              placeholder="Fecha Final"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="col-6">
            <h6>Buscar empleado sustituido</h6>
          </div>
        </div>
        <div class="row">
          <div class="form-group-h col-3">
            <input
              v-model="personaBuscadaQueSustituye"
              class="form-control"
              type="text"
              placeholder="Nombre del empleado"
            />
          </div>
          <div class="form-group d-flex align-items-center col-3">
            <button
              type="button"
              v-on:click="BuscarPersonasParaReemplazo()"
              class="btn btn-primary"
            >
              Buscar
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <h6>Seleccionar empleado sustituido</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-12 table-responsive">
            <table
              class="table  table-striped table-light table-hover"
              id="tabla_PersonasSustituidas"
              data-toggle="table"
              data-pagination="true"
              data-page-size="10"
              data-search="true"
              data-single-select="true"
              data-click-to-select="true"
            >
              <thead class="thead-custom">
                <tr>
                  <th data-checkbox="true"></th>
                  <th data-field="Nombre" data-sortable="true">
                    Nombre
                  </th>
                  <th data-field="ApellidoPaterno" data-sortable="true">
                    Apellido Paterno
                  </th>
                  <th data-field="ApellidoMaterno" data-sortable="true">
                    Apellido Materno
                  </th>
                  <!-- <th data-field="FechaInicial" data-sortable="true">
                    Fecha Inicial
                  </th>
                  <th data-field="FechaFinal" data-sortable="true">
                    Fecha Final
                  </th> -->
                  <!-- <th data-field="" data-sortable="true">
                    Persona a quién cubre
                  </th> -->
                  <!-- <th                       
                    data-events="operateEvents"                 
                    :data-formatter="this.operateFormatterNombramientos()"
                  >
                    Acciones
                  </th> -->
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="col-12">
            <h6>Observaciones</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <textarea
              v-model="observacion"
              class="form-control"
              name="observacionesDelNombramiento"
              placeholder="Observaciones del nombramiento"
            ></textarea>
          </div>
        </div>

        <div class="row">
          <div class="form-group text-right col-12">
            <button
              type="button"
              v-on:click="GuardarNombramiento()"
              class="btn btn-primary"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";
import router from "@/router/index";

export default {
  props: ["propNombramientoId"],
  data() {
    return {
      enumeraciones,
      fechaInicial: null,
      fechaFinal: null,
      personasEncontradas: [],
      personasSustituidas: [],
      nombramientosEncontrados: [],
      busquedaPersonaParaNombramiento: null,
      personaBuscadaQueSustituye: null,
      observacion: null,
      numeroDeOficio: null,
      asunto: null,
      //expediente: null,
      fundamentoLegalId: null,
      fechaDeExpedicion: null,
      tipoPlantillaDeNombramientoId: null,
      tipoAsuntoId: null
    };
  },

  components: {
    C036FundamentosLegales: catalogos.PJ.C036FundamentosLegales,
    C037TiposPlantillasDeNombramientos:
      catalogos.SIAP.C037TiposPlantillasDeNombramientos,
    C043TiposAsunto: catalogos.SIAP.C043TiposAsunto
  },
  mounted() {
    this.propNombramientoId != null ? this.BuscarNombramientoPorId() : false;
  },
  methods: {
    ///Inicia los eventos que tendran los iconos de las acciones
    IniciarEventosDeLasAcciones() {
      // (e, value, row, index)
      window.operateEvents = {
        "click .cargar-nombramientos": (e, val, row, index) => {
          this.BuscarNombramientosPorPersona(row.PersonaId);
          //this.cargarNombramientos(row.PersonasId);
        },
        "click .editar-nombramiento": (e, val, row, index) => {
          console.log(row);
          //this.cargarNombramientos(row.PersonasId);
        }
      };
    },

    CambioFundamentoLegal(datos) {
      this.fundamentoLegalId = datos.FundamentoLegalId;
    },

    CambioTipoAsunto(datos){            
      this.tipoAsuntoId = datos.valor; 
               
    },

    CambioTipoPlantillaSeleccionada(datos) {
      this.tipoPlantillaDeNombramientoId = datos.FundamentoLegalId;
    },

    BuscarNombramientoPorId() {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        nombramientoId: this.propNombramientoId
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.ObtenerNombramientoPorId,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            console.log(response.data);

            this.nombramientosEncontrados = response.data.Nombramientos;

            var listaPersonasSustituidas = [];
            if (response.data.Nombramientos[0].PersonaSustituida != undefined) {
              listaPersonasSustituidas.push(
                response.data.Nombramientos[0].PersonaSustituida
              );
            }
            this.personasSustituidas = listaPersonasSustituidas;

            this.LlenarInfoNombramientos();
          } else {
            console.log(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    BuscarPersonasParaNombramiento() {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        busqueda: this.busquedaPersonaParaNombramiento
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.ObtenerPersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            console.log(response.data);

            this.personasEncontradas = response.data.Personas;
            //this.LlenarTablaPersonasSustituidas();
            this.LlenarTablaPersonasNombradas();
          } else {
            console.log(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    BuscarPersonasParaReemplazo() {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        busqueda: this.personaBuscadaQueSustituye
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.ObtenerPersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            this.personasSustituidas = response.data.Personas;
            this.LlenarTablaPersonasSustituidas();
          } else {
            console.log(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    LlenarTablaPersonasNombradas() {
      var personasEncontradasParaSerNombradas = [];
      this.personasEncontradas.forEach(persona => {
        var PersonaNombrada = {
          PersonaNombrada: {
            PersonaId: persona.PersonaId,
            Nombre: persona.Nombre,
            ApellidoPaterno: persona.ApellidoPaterno,
            ApellidoMaterno: persona.ApellidoMaterno
          }
        };
        personasEncontradasParaSerNombradas.push(PersonaNombrada);
      });
      var $tabla_Personas = $("#tabla_PersonaDelNombramiento");
      $tabla_Personas.bootstrapTable({
        data: personasEncontradasParaSerNombradas
      });
      $tabla_Personas.bootstrapTable(
        "load",
        personasEncontradasParaSerNombradas
      );
    },
    LlenarTablaPersonasSustituidas() {
      var $tabla_PersonasSustituidas = $("#tabla_PersonasSustituidas");
      $tabla_PersonasSustituidas.bootstrapTable({
        data: this.personasSustituidas
      });
      $tabla_PersonasSustituidas.bootstrapTable(
        "load",
        this.personasSustituidas
      );
      if(this.nombramientosEncontrados.length > 0)
      {
        this.fechaInicial = this.nombramientosEncontrados[0].FechaInicial;
        this.fechaFinal = this.nombramientosEncontrados[0].FechaFinal;
      }
    },
    LlenarInfoNombramientos() {
      //Llena la tabla de persona(s) nombradas
      var $tabla_Personas = $("#tabla_PersonaDelNombramiento");
      $tabla_Personas.bootstrapTable({ data: this.nombramientosEncontrados });
      $tabla_Personas.bootstrapTable("load", this.nombramientosEncontrados);
      $tabla_Personas.bootstrapTable("check", 0);

      var $tabla_PersonasSustituidas = $("#tabla_PersonasSustituidas");
      $tabla_PersonasSustituidas.bootstrapTable({
        data: this.personasSustituidas
      });
      $tabla_PersonasSustituidas.bootstrapTable(
        "load",
        this.personasSustituidas
      );

      if ($tabla_PersonasSustituidas.bootstrapTable("getData").length == 1) {
        $tabla_PersonasSustituidas.bootstrapTable("check", 0);
      }

      this.fechaInicial = this.nombramientosEncontrados[0].FechaInicial;
      this.fechaFinal = this.nombramientosEncontrados[0].FechaFinal;

      this.observacion = this.nombramientosEncontrados[0].Observacion;
    },
    GuardarNombramiento() {
      var $tabla_Personas = $("#tabla_PersonaDelNombramiento");
      var personaNombradaSeleccionada = $tabla_Personas.bootstrapTable(
        "getSelections"
      );

      var $tabla_PersonasSustitidas = $("#tabla_PersonasSustituidas");
      var personaSustituidaSeleccionada = $tabla_PersonasSustitidas.bootstrapTable(
        "getSelections"
      );

      if (personaNombradaSeleccionada.length > 0) {
        //Obtiene el Id de la persona nombrada
        var personaIdNombradaSeleccionada =
          personaNombradaSeleccionada[0].PersonaNombrada.PersonaId;

        // Obtiene el Id de la persona a la que sustituye
        var personaIdSustituidaSeleccionada =
          personaSustituidaSeleccionada.length > 0
            ? personaSustituidaSeleccionada[0].PersonaId
            : null;

        if (personaIdNombradaSeleccionada > 0) {
          var nombramientoId =
            this.nombramientosEncontrados != undefined &&
            this.nombramientosEncontrados.length > 0
              ? this.nombramientosEncontrados[0].NombramientoId
              : null;

          this.EnviarNombramiento(
            personaIdNombradaSeleccionada,
            personaIdSustituidaSeleccionada,
            nombramientoId
          );
        }
      } else {
        alert(
          "Debe estár seleccionado el empleado que recibe el nombramiento."
        );
      }
    },
    ValidarFormulario() {
      if (this.numeroDeOficio == null || this.numeroDeOficio == undefined) {
        comun.mensajeDeAlerta(
          "El número de oficio no debe estár vacío",
          null,
          null
        );
        return false;
      }
      if (this.tipoAsuntoId == null || this.tipoAsuntoId == undefined) {
        comun.mensajeDeAlerta("El asunto no debe de estar vacío", null, null);
        return false;
      }
      if (
        this.fechaDeExpedicion == null ||
        this.fechaDeExpedicion == undefined
      ) {
        comun.mensajeDeAlerta(
          "Debe seleccionar un valor para la fecha de expedición",
          null,
          null
        );
        return false;
      }
      if (this.fechaInicial == null || this.fechaInicial == undefined) {
        comun.mensajeDeAlerta(
          "La fecha inicial del nombramiento está vacía",
          null,
          null
        );
        return false;
      }
      if (this.fechaFinal == null || this.fechaFinal == undefined) {
        comun.mensajeDeAlerta(
          "La fecha final del nombramiento está vacía",
          null,
          null
        );
        return false;
      }
      return true;
    },

    EnviarNombramiento(
      personaIdNombradaSeleccionada,
      personaIdSustituidaSeleccionada,
      nombramientoId
    ) {
      if (this.ValidarFormulario() == true) {
        comun.SeEstaCargandoInformacion(true);
        let peticion = {
          PersonaIdNombradaSeleccionada: personaIdNombradaSeleccionada,
          PersonaIdSustituidaSeleccionada: personaIdSustituidaSeleccionada,
          NombramientoId: nombramientoId,
          Observacion: this.observacion,
          FechaInicial: this.fechaInicial,
          FechaFinal: this.fechaFinal,
          NumeroDeOficio: this.numeroDeOficio,
          //Asunto: this.asunto,
          TipoAsuntoId: this.tipoAsuntoId,
          //Expediente: this.expediente,
          //FundamentoLegalId: this.fundamentoLegalId,
          FechaDeExpedicion: this.fechaDeExpedicion,
          //TipoPlantillaDeNombramientoId: this.tipoPlantillaDeNombramientoId
        };

        axios
          .post(
            api.conexion + api.SIAP.funcion.GuardarNombramiento,
            peticion,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal
            )
          )
          .then(response => {
            if (response.data.SiHayError == false) {
              console.log(response.data);
              comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
              //router.push({ name: "Nombramientos" });
            } else {
              console.log(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch(e => {
            console.error(e);
            comun.mensajeDeAlerta(
              comun.mensajeDeError(enumeraciones.error.E500),
              null,
              null
            );
            comun.SeEstaCargandoInformacion(false);
          });
      }
    }
  }
};
</script>

<style scoped>
/* Se requiere para que el color del texto de la tabla sea negro */
table {
  color: #343a40 !important;
}
.thead-custom {
  background-color: #004746;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Nombramientos/Nombramientos.vue